exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip[data-v-9164f308]{background:#222;color:#fff;padding:8px 12px;border-radius:4px;font-size:14px;pointer-events:none;white-space:nowrap;box-shadow:0 2px 8px rgba(0,0,0,.15);opacity:1}", ""]);

// exports
